import styled from "styled-components";
import PrimaryButton from "../../../../helperComponents/PrimaryButton.js";

import { useContext, useEffect, useRef, useState } from "react";
import Context from "../../../../../Context.js";
import goTo from "../../../../../controllers/goTo.js";
import { useTranslation } from "react-i18next";
import BrandContainer from "../../../../brand/BrandContainer.js";
import AnimatedPage from "../../../loggedIn/AnimatedPage.js";
import LoggedOutPillTabs from "./LoggedOutPillTabs.js";
import UpcomingActivitiesPage from "../../../loggedIn/activity/upcomingActivities/UpcomingActivitiesPage.js";
import LoggedOutMembershipSection from "../LoggedOutMembershipSection.js";
import MembershipSelection from "../../../loggedIn/onboarding/MembershipSelection.js";
import LoggedInMembershipPage from "../../../loggedIn/membership/LoggedInMembershipPage.js";
import LoggedInMembershipPlans from "../../../loggedIn/membership/LoggedInMembershipPlans.js";
import ShopPage from "../../../loggedIn/shop/ShopPage.js";

const ParentContainer = styled.div`
  display: flex;
  width: 100vw;
  min-height: 100vh;
  color: var(--element);
  background-color: var(--surface2);
  /* background-color: red; */

  flex-direction: column;
  align-items: center;
  overflow: hidden;

  justify-content: flex-start;
  gap: 0;
  /* justify-content: space-between; */
  /* background-color: pink; */
  align-items: center;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const Tagline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;

  @media (max-width: 900px) {
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

const TaglineLine = styled.div`
  color: var(--element);

  font-family: var(--headingFont);
  font-weight: 900;
  /*  */

  font-size: 12vw;

  width: 100%;
`;

const TaglineLine2 = styled(TaglineLine)`
  /* font-size: 49px; */
`;

const MainButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-bottom: 30px;

  @media (max-width: 900px) {
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
`;

const Medium = styled.div`
  font-size: 18px;

  color: var(--element);
  opacity: 0.5;

  /* font-family: "Lemon Milk Pro", "Questrial", serif; */

  width: 100%;
  padding: 0;
  font-size: 16px;
  line-height: 23px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
  margin-top: 10px;
  width: 100%;
  /* background-color: red; */
`;

const AnimatedHeroImage = styled.img`
  border-radius: 15px;
  height: 50vh;
  width: 100vw;
  object-fit: cover;
`;

const Top = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* position: absolute;
  top: 0;
  left: 0; */

  width: 100%;
  padding: 20px 20px;
  /* display: none; */
`;

const Information = styled.div`
  /* display: none; */
  /* position: absolute; */
  /* bottom: 0; */
  padding: 25px 35px;
  padding-bottom: 40px;
  padding-top: 0;
  /* padding-top: 240px; */
  width: 100%;
  /* margin-top: 100px; */

  /* box-shadow: 0 -10px 50px 50px #000; */
  /* background: linear-gradient(180deg, transparent, 30%, #000); */
`;

const SmallText = styled.div`
  font-size: 10px;
  opacity: 0.5;
  margin-top: 15px;
  text-transform: capitalize;
  margin-bottom: -25px;
  width: 100%;
  text-align: left;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  /* background-color: red; */
  /* display: none; */
  padding: 25px;
`;

const Choco = styled.div`
  background-color: red;
  height: 200px;
  width: 200px;
  border-radius: 10px;
`;

const ElevatedSection = styled.div`
  background-color: var(--surface);
  border-bottom: 1px solid var(--border);
  margin-bottom: 25px;
`;

export default function LoggedOutHomeForApp() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();

  // return <Choco></Choco>;

  return (
    <AnimatedPage>
      <ParentContainer id="scrollableParent">
        <ElevatedSection>
          <Top>
            <BrandContainer />

            <PrimaryButton
              containerStyle={{ width: "200px" }}
              icon={null}
              onClick={goTo("/signup")}
              textStyle={{ fontSize: "11px" }}
              style={
                {
                  // minWidth: "120px",
                  // height: "40px",
                  // padding: "15px 0",
                  // borderRadius: "50px",
                  // boxShadow:
                  //   "1px 5px 0 0 rgb(96 124 28), 1px 5px 50px 0 rgb(96 124 28)",
                }
              }
            >
              Commencer
            </PrimaryButton>
          </Top>

          <Information>
            <TextContainer>
              <Tagline>
                <TaglineLine>{t("loggedOutHeroTitleLine1")}</TaglineLine>
                <TaglineLine2>{t("loggedOutHeroTitleLine2")}</TaglineLine2>
              </Tagline>

              <Medium> {t("loggedOutHeroDesc")} </Medium>

              <MainButtons>
                <SmallText>Developpé par Djizef SARL</SmallText>
              </MainButtons>
            </TextContainer>
          </Information>
        </ElevatedSection>

        <LoggedOutPillTabs
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          tabs={["Activités", "Adhésion", "Boutique"]}
          onChange={(index) => console.log("Selected tab:", index)}
        />

        <Content>{getContent()}</Content>
      </ParentContainer>
    </AnimatedPage>
  );

  function getContent() {
    // return null;
    if (activeIndex === 0)
      return <UpcomingActivitiesPage onlyRenderContent={true} />;
    if (activeIndex === 1)
      return <MembershipSelection onlyRenderContent={true} />;
    if (activeIndex === 2) return <ShopPage onlyRenderContent={true} />;
    // return <UpcomingActivitiesPage onlyRenderContent={true} />;
  }
}
